import * as FORM_LABEL from 'constant/form-labels'
import React, { useEffect } from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import NameInput from 'view/component/form-items/name-input'
import GroupUuidInput from 'view/component/form-items/group-uuid-input'

const PermittedGroupForm = ({ group, siteUuid, form }) => {
  useEffect(() => {
    form.setFieldsValue(group)
  }, [group])

  return (
    <Form
      form={form}
      layout='vertical'
    >
      <NameInput title={FORM_LABEL.GROUP_NAME} />
      <GroupUuidInput />
    </Form>
  )
}

PermittedGroupForm.propTypes = {
  form: PropTypes.object,
  group: PropTypes.object,
  siteUuid: PropTypes.string
}
export default PermittedGroupForm
